import React from "react";
import { useI18n } from "@/i18n";

export default function Footer() {
  const appVersion = process.env.NEXT_PUBLIC_APP_VERSION || "v?.??";
  const currentYear = new Date().getFullYear();
  const { t } = useI18n();

  return (
    <footer
      data-app-footer="layout"
      className="fixed bottom-0 left-0 w-full bg-black text-white z-50"
    >
      <div className="relative flex justify-center items-center py-2 px-4 border-t border-gray-700">
        <div className="text-xs text-center">
          {t("layout.footer.copyright", {
            year: currentYear,
            patents: "180172.245, 181924.913",
          })}
        </div>
        <div className="absolute right-4 bottom-1 text-xs">{appVersion}</div>
      </div>
    </footer>
  );
}
